import {
  Grid,
  List,
  ListItem,
  ListItemButton,
  Divider,
  Paper,
} from "@mui/material";

const PromptList = ({ prompts, handleSelect }) => {
  return (
    <Paper elevation={3} style={{width: '100%'}}>
      <List>
        {prompts.map((prompt, p) => {
          return (
            <div key={`${p}-${prompt._id}`}>
              <ListItem
                key={`listitem-${prompt._id}`}
              >
                <ListItemButton
                  onClick={() => {
                    handleSelect(prompt._id);
                    
                  }}
                >
                  {prompt?.name}
                </ListItemButton>
              </ListItem>
              <Divider />
            </div>
          );
        })}
      </List>
    </Paper>
  );
};

export default PromptList;
